export enum QuestionnaireAutoReminderFrequencyType {
  daily = "DAILY",
  weekly = "WEEKLY",
}

export enum QuestionnaireInactiveFrequencyType {
  days = 1,
  weeks = 2,
  months = 3,
}